const columns = document.querySelectorAll(".my-account-column");
const loginRegisterPage = document.querySelector(".login-register-page");

columns.forEach((column) => {
  column.addEventListener("click", () => {
    // Remove the 'active' class from all columns
    columns.forEach((c) => c.classList.remove("active"));
    // Add the 'active' class to the clicked column
    column.classList.add("active");

    // Check if the clicked column has class 'login'
    if (column.classList.contains("login")) {
      // Set the class of login-register-page to "left"
      loginRegisterPage.className = "grid-container login-register-page left";
    } else if (column.classList.contains("register")) {
      // Set the class of login-register-page to "right"
      loginRegisterPage.className = "grid-container login-register-page right";
    }
  });
});
